import { CalendarDays, type LucideIcon } from 'lucide-react';

export const DateIcon: LucideIcon = CalendarDays;
